import { Component } from "react";
import type { ChangeEvent, ComponentType, MouseEvent, ReactNode } from "react";
import Modal from "views/components/modal";
import style from "./style.module.css";
import InfoAlertUntyped from "views/components/InfoAlert";

export interface ModalButton {
  name: string;
  theme?: string;
  disabled?: boolean;
  isLoading?: boolean;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

interface InfoAlertProps {
  children?: ReactNode;
  className?: string;
  hasIcon?: boolean;
  iconSize?: string;
  spanClass?: string;
  theme?: string;
}

const InfoAlert = InfoAlertUntyped as ComponentType<InfoAlertProps>;

interface RequestApprovalModalProps {
  designId: string;
  isOpen: boolean;
  onCloseModal: () => void;
  onRequestDesignApproval: (args: {
    designId: string;
    comment: string;
  }) => void;
}

interface RequestApprovalModalState {
  comment: string;
}

class RequestApprovalModal extends Component<
  RequestApprovalModalProps,
  RequestApprovalModalState
> {
  static displayName = "RequestApprovalModal";

  static defaultState: RequestApprovalModalState = {
    comment: ""
  };

  constructor(props: RequestApprovalModalProps) {
    super(props);

    this.state = RequestApprovalModal.defaultState;

    this.returnToDefaultState = this.returnToDefaultState.bind(this);
    this.handleApprovalRequestClick =
      this.handleApprovalRequestClick.bind(this);
  }

  returnToDefaultState() {
    this.setState(RequestApprovalModal.defaultState);
  }

  handleApprovalRequestClick() {
    this.props.onRequestDesignApproval({
      designId: this.props.designId,
      comment: this.state.comment
    });
    this.props.onCloseModal();
    this.returnToDefaultState();
  }

  render() {
    const buttonsList: ModalButton[] = [
      {
        name: "Cancel",
        theme: "gray",
        onClick: this.props.onCloseModal
      },
      {
        name: "Request",
        theme: "blueSolid",
        onClick: this.handleApprovalRequestClick
      }
    ];
    return (
      <Modal
        className={style.wrapper}
        isOpen={this.props.isOpen}
        contentLabel="Request Approval"
        onRequestClose={this.props.onCloseModal}
        header={"Request Approval"}
        buttons={buttonsList}
      >
        <div>
          <div className={style.description}>
            This design requires approval from a Brand Manager in your team
            before it can be downloaded or purchased.
          </div>
          <InfoAlert className={style.alert}>
            All resizes of this design will require separate approval.
          </InfoAlert>
          <div className={style.textareaLabel}>Write a comment (optional)</div>
          <textarea
            className={style.textarea}
            placeholder="E.g. I'm requesting approval for this design because…"
            value={this.state.comment}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
              this.setState({ comment: e.target.value })
            }
          />
        </div>
      </Modal>
    );
  }
}

export default RequestApprovalModal;
